import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import TestimonialModal from '../../../../../components/modals/UserProfile/TestimonialModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserTestimonial, updateUserTestimonial, deleteUserTestimonial } from '../../../../../redux/slice/allUsersSlice';
import PreviewModal from '../../../../../components/modals/previewModal';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';
import { UserInital } from '../../../../../utils/otherHelopers';

const Testimonials = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewMediaArray, setPreviewMediaArray] = useState([]);

    const { testimonialLoading } = useSelector((state) => state.allUsers);

    const handleUpsertTestimonial = (data) => {
        const action = currentItem
            ? updateUserTestimonial({ id: id, testimonialId: currentItem.id, data })
            : addUserTestimonial({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Testimonial ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} testimonial`);
            });
    };

    const handleDeleteTestimonial = () => {
        dispatch(deleteUserTestimonial({ id: id, testimonialId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Testimonial deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete testimonial");
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Testimonial</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />

            </div>
            {userDetail?.testimonials?.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {userDetail.testimonials.map((test, index) => (
                        <div key={index} className="p-3 border rounded-3 bg-light-subtle position-relative custom-card">
                            <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                <button
                                    className="post-action-btn edit-btn border bg-white"
                                    onClick={() => {
                                        setCurrentItem(test);
                                        setShowModal(true);
                                    }}
                                >
                                    <EditIcon width={14} height={14} color="#007bff" />
                                </button>
                                <button
                                    className="post-action-btn delete-btn text-danger border bg-white"
                                    onClick={() => {
                                        setItemToDelete(test.id);
                                        setShowDeletePopup(true);
                                    }}
                                >
                                    <Delete02Icon size={14} />
                                </button>
                            </div>
                            <div className={`d-flex gap-3 ${!test.description ? 'align-items-center' : 'align-items-start'}`}>
                                <UserInital image={test.file?.url} name={test.name} width={56} className='cursor-pointer' onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setPreviewMediaArray([{
                                        url: test.file.url,
                                        title: test.name || "Testimonial Image",
                                        type: "image"
                                    }]);
                                    setShowPreviewModal(true);
                                }}
                                    onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />

                                <div className={`flex-grow-1 ${test.description ? 'mt-1' : ''}`}>
                                    <h6 className="mb-0 fw-bold text-dark fs-6">{test.name || "-"}</h6>
                                    {test.description && (
                                        <p className="mb-0 text-secondary text-break mt-2" style={{ lineHeight: '1.6', fontStyle: 'italic', fontSize: '14px' }}>"{test.description}"</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No testimonials listed.</p>
                </div>
            )}

            <TestimonialModal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setCurrentItem(null);
                }}
                onSubmit={handleUpsertTestimonial}
                testimonial={currentItem}
                isLoading={testimonialLoading}
                title={currentItem ? "Edit Testimonial" : "Add Testimonial"}
                size="lg"
            />

            <DeletePopup
                show={showDeletePopup}
                onHide={() => {
                    setShowDeletePopup(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDeleteTestimonial}
                content="Are you sure you want to delete this testimonial?"
                saveTitle="Delete"
                disabled={testimonialLoading}
            />

            <PreviewModal
                show={showPreviewModal}
                onHide={() => setShowPreviewModal(false)}
                previewMedia={previewMediaArray}
                initialIndex={0}
            />
        </div>
    );
};

export default Testimonials;
